import { c as _c } from "react/compiler-runtime";
import styles from './HeroSection.module.css';
function HeroVideo(t0) {
  const $ = _c(2);
  const {
    videoUrl
  } = t0;
  let t1;
  if ($[0] !== videoUrl) {
    t1 = <div className={styles.heroVideoContainer}><iframe title="hero video" src={videoUrl} allowFullScreen={true} width={530} height={276} /></div>;
    $[0] = videoUrl;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
export default HeroVideo;